export const API_KEY = "LdFMCX141cg7SIPaTF7MtLf9wptuQAeG";
// export const API_PREFIX = "http://localhost:5000/apis";
export const API_PREFIX = "http://shaofanlai.com/apis";



// WEBPACK FOOTER //
// ./src/Configuration.js